import { withHooks } from '../../hoc'
import useNumberInput from '../useNumberInput'
import useNativeInput from '../useNativeInput'
import Input from './Input'

export default withHooks(props => props.type === 'number' && useNumberInput(props), useNativeInput)(Input)
